"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getLogoNameBrandName = function (brandName) {
    if (!brandName) {
        return 'cbLogo';
    }
    var brandNameToLogo = {
        CodeDefender: 'appleLogo'
    };
    return brandNameToLogo[brandName] || 'cbLogo';
};
exports.default = getLogoNameBrandName;
